import { Injectable } from "@angular/core";
import { UserService } from "../user.service";
import { ServerRoutes } from "src/app/ServerRoutes";
import { HttpClient } from "@angular/common/http";

@Injectable({
	providedIn: "root",
})
export class AtendimentoService {
	constructor(
		private http: HttpClient,
		private routes: ServerRoutes,
		private userService: UserService
	) {}

	getAtendimentos(offset, limite, status) {
		return this.routes.requisicaoHTTP(
			this.http.get(
				this.routes.getMeusAtendimentos(offset, limite, status),
				this.userService.getHeader()
			)
		);
	}

	getAtendimentosWithoutBloqued(offset, limite, status) {
		return this.routes.requisicaoHTTP(
			this.http.get(
				this.routes.getAtendimentosWithoutBloqued(offset, limite, status),
				this.userService.getHeader()
			)
		);
	}

	recusarAtendimento(atendimento) {
		return this.routes.requisicaoHTTP(
			this.http.post(
				this.routes.recusarAtendimento(atendimento),
				{},
				this.userService.getHeader()
			)
		);
	}

	blockFreeHour(atendimento) {
		return this.routes.requisicaoHTTP(
			this.http.post(
				this.routes.blockFreeHour,
				atendimento,
				this.userService.getHeader()
			)
		);
	}

	addNewHour(atendimento) {
		return this.routes.requisicaoHTTP(
			this.http.post(
				this.routes.addNewHour,
				atendimento,
				this.userService.getHeader()
			)
		);
	}

	unblockFreeHour(atendimento) {
		return this.routes.requisicaoHTTP(
			this.http.post(
				this.routes.unblockFreeHour,
				atendimento,
				this.userService.getHeader()
			)
		);
	}

	removeFreeHour(atendimento) {
		return this.routes.requisicaoHTTP(
			this.http.post(
				this.routes.removeFreeHour,
				atendimento,
				this.userService.getHeader()
			)
		);
	}

	blockAllDay(atendimento) {
		return this.routes.requisicaoHTTP(
			this.http.post(
				this.routes.blockAllDay,
				atendimento,
				this.userService.getHeader()
			)
		);
	}

	getVideocall(codigo) {
		return this.routes.requisicaoHTTP(
			this.http.get(
				this.routes.getVideocall(codigo),
				this.userService.getHeader()
			)
		);
	}

	comentarAtendimento(id, comentario) {
		return this.routes.requisicaoHTTP(
			this.http.post(
				this.routes.postComentario(id),
				{ comentario },
				this.userService.getHeader()
			)
		);
	}

	getAtendimentosUser(userId, offset, limite) {
		return this.routes.requisicaoHTTP(
			this.http.get(
				this.routes.getAtendimentosCliente(userId, offset, limite),
				this.userService.getHeader()
			)
		);
	}
}
